import { FC, useState } from "react";
import styles from "./AdminSettings.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { AdminParametrs } from "../../components/AdminPanel/AdminParametrs";
import { AdminServices } from "../../components/AdminPanel/AdminServices";
import { AdminClubs } from "../../components/AdminPanel/AdminClubs";
import { MenuTabs } from "../../components/MenuTabs/MenuTabs";
import { ModelBlockItem } from "./ModelBlockItem";
import { AdminClaim } from "../../components/AdminPanel/AdminClaim";

export const AdminSettings: FC = () => {
  const router = useLocation();
  const headerData = ["nicht verifiziert", "Verefifiziert", "Verboten"];
  const [header, setHeader] = useState("nicht verifiziert");
  const headerDataDelete = ["Hinzufügung", "Entfernt"];
  const [headerDelete, setHeaderDelete] = useState("Hinzufügung");
  const [headerClaim, setHeaderClaim] = useState("nicht berücksichtigt");
  const headerDataClaim = ["nicht berücksichtigt", "abgelehnt", "angenommen"];

  return (
    <div className={styles.block}>
      <MenuTabs type="admin" />
      <div className={styles.adminPage}>
        <div className={styles.verification}>
          {router.pathname === "/admin" &&
            headerData.map((item) => (
              <button
                type="button"
                onClick={() => setHeader(item)}
                className={`${styles.verification_header} ${
                  header === item && styles.verification_header_active
                }`}
              >
                {item}
              </button>
            ))}
          {router.pathname !== "/admin" &&
            router.pathname !== "/admin/claim" &&
            headerDataDelete.map((item) => (
              <button
                type="button"
                onClick={() => setHeaderDelete(item)}
                className={`${styles.verification_header} ${
                  headerDelete === item && styles.verification_header_active
                }`}
              >
                {item}
              </button>
            ))}
          {router.pathname === "/admin/claim" &&
            headerDataClaim.map((item) => (
              <button
                type="button"
                onClick={() => setHeaderClaim(item)}
                className={`${styles.verification_header} ${
                  headerClaim === item && styles.verification_header_active
                }`}
              >
                {item}
              </button>
            ))}
        </div>

        {router.pathname === "/admin" && header === "nicht verifiziert" && (
          <ModelBlockItem type="nicht" />
        )}
        {router.pathname === "/admin" && header === "Verefifiziert" && (
          <ModelBlockItem type="Verefifiziert" />
        )}
        {router.pathname === "/admin" && header === "Verboten" && (
          <ModelBlockItem type="Verboten" />
        )}
        {router.pathname === "/admin/parameters" &&
          headerDelete === "Hinzufügung" && <AdminParametrs isDelete={false} />}
        {router.pathname === "/admin/parameters" &&
          headerDelete === "Entfernt" && <AdminParametrs isDelete={true} />}
        {router.pathname === "/admin/image" &&
          headerDelete === "Hinzufügung" && <AdminClubs isDelete={false} />}
        {router.pathname === "/admin/image" && headerDelete === "Entfernt" && (
          <AdminClubs isDelete={true} />
        )}
        {router.pathname === "/admin/intim" &&
          headerDelete === "Hinzufügung" && <AdminServices isDelete={false} />}
        {router.pathname === "/admin/intim" && headerDelete === "Entfernt" && (
          <AdminServices isDelete={true} />
        )}
        {router.pathname === "/admin/claim" &&
          headerClaim === "nicht berücksichtigt" && (
            <AdminClaim type="nicht berücksichtigt" />
          )}
        {router.pathname === "/admin/claim" && headerClaim === "abgelehnt" && (
          <AdminClaim type="abgelehnt" />
        )}
        {router.pathname === "/admin/claim" && headerClaim === "angenommen" && (
          <AdminClaim type="angenommen" />
        )}
      </div>
    </div>
  );
};
